import api from "./api";

// Guest–host conversations (API: /api/v2/chat/). Hosts see the "vendor"
// side of each thread.

export const LISTING_PATHS = { home: "homes", hotel: "hotels", experience: "experience", event: "events" };
export const SITE_URL = "https://www.tubayo.com";

export async function fetchConversations(page = 1) {
  const res = await api.get(`chat/conversations/?page=${page}`);
  return res.data;
}

export async function fetchConversation(id) {
  const res = await api.get(`chat/conversations/${id}/`);
  return res.data.data;
}

export async function fetchMessages(conversationId, before) {
  const query = before ? `?before=${before}` : "";
  const res = await api.get(`chat/conversations/${conversationId}/messages/${query}`);
  // Newest first from the API; shown oldest first.
  return { messages: res.data.results.slice().reverse(), hasMore: res.data.has_more };
}

export async function sendMessage(conversationId, body, clientId) {
  const res = await api.post(`chat/conversations/${conversationId}/messages/`, { body, client_id: clientId });
  return res.data.data;
}

export async function markRead(conversationId) {
  const res = await api.post(`chat/conversations/${conversationId}/read/`);
  return res.data.unread_total;
}

export async function fetchUnreadTotal() {
  const res = await api.get("chat/unread-count/");
  return res.data.unread_total;
}

/** The conversation with a booking's guest (kind: home | hotel | experience | event). */
export async function openBookingConversation(kind, bookingId) {
  const res = await api.post("chat/conversations/", { booking_type: kind, booking_id: bookingId });
  return res.data.data;
}

export function conversationContext(c) {
  if (c.kind === "listing") return c.role === "vendor" ? `Guest · ${c.listing?.title}` : c.listing?.title;
  return c.role === "vendor" ? `Customer · ${c.store?.name}` : "Shop";
}

/** Which side of the conversation the signed-in user is on. */
export function myIdIn(c) {
  if (!c) return "";
  return c.role === "customer" ? c.customer?.id : c.host?.id || c.store?.owner_id || "";
}
